import { attachComponentData } from '@backstage/core-plugin-api';

import { ContentActionBarCreateButton } from './ContentActionBarCreateButton';
import {
  PAGE_CONTENT_ACTION_BAR_KEY,
  type PageContentActionBarProps,
} from './composition';

export type { PageContentActionBarProps };

const ContentActionBarSlot = (_props: PageContentActionBarProps): null => null;

attachComponentData(ContentActionBarSlot, PAGE_CONTENT_ACTION_BAR_KEY, true);

export const ContentActionBar = Object.assign(ContentActionBarSlot, {
  CreateButton: ContentActionBarCreateButton,
});
